// extracted by mini-css-extract-plugin
export default {"option":"InputCheckbox_option__scqtU","optionChecked":"InputCheckbox_optionChecked__-Pl+D","ckeckbox":"InputCheckbox_ckeckbox__ztsmH"};